import { render, staticRenderFns } from "./OverviewPage.vue?vue&type=template&id=ff6bef1e&scoped=true"
import script from "./OverviewPage.vue?vue&type=script&lang=js"
export * from "./OverviewPage.vue?vue&type=script&lang=js"
import style0 from "./OverviewPage.vue?vue&type=style&index=0&id=ff6bef1e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff6bef1e",
  null
  
)

export default component.exports